import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { IContract } from '../../../../../../types/contract';
import {
  ContractExtractionResult,
  Paragraph,
} from '../../../../../../types/aiOutput';
import { DialogMode } from '../../../../../../types/dialogmode';
import { IPrompt } from '../../../../../../types/prompt';
import { IDocument } from '../../../../../../types/document';
import { HumanDataVerification } from '../../../../../../types/humanDataVerification';
import ContractPromptAccordion from '../../ContractPromptAccordion';

interface PromptsSectionProps {
  contract: IContract;
  prompts: IPrompt[];
  mode: DialogMode;
  aiOutputs: ContractExtractionResult[];
  selectParagraph: (
    paragraph?: Paragraph,
    prompt?: IPrompt,
    aiOutput?: ContractExtractionResult
  ) => void;
  expanded?: string;
  infoFound: boolean;
  verifications?: HumanDataVerification[];
  documents: IDocument[];
}

const PromptsSection: React.FC<PromptsSectionProps> = ({
  contract,
  prompts,
  mode,
  aiOutputs,
  selectParagraph,
  expanded,
  infoFound,
  verifications,
  documents,
}) => {
  const { t } = useTranslation();

  const [promptsCorrectCount, setPromptsCorrectCount] = useState<number>(0);
  const [promptsIncorrectCount, setPromptsIncorrectCount] = useState<number>(0);
  const [promptsUnknownCount, setPromptsUnknownCount] = useState<number>(0);

  return (
    <Box display="flex" flexDirection="column" gap={5}>
      <Box>
        {prompts.map((prompt) => {
          return (
            <ContractPromptAccordion
              key={`contractPromptAccordion-${prompt.id}`}
              prompt={prompt}
              contract={contract}
              mode={mode}
              aiOutputs={aiOutputs}
              selectParagraph={selectParagraph}
              isExpanded={expanded === prompt.id}
              infoFound={infoFound}
              documents={documents}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default PromptsSection;
